import React from 'react';

import styled from 'styled-components';
import { FaChevronRight } from "react-icons/fa";
import Astronaut from '../img/astronaut.png';

const EarnProContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10%;
  background: #ffffff;
  color: black;
  min-height: 500px;

  @media (max-width: 1024px) {
    flex-direction: column;
    text-align: center;
    padding: 3rem 5%;
  }
`;

const EarnProImage = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 100%;
    height: auto;
  }

  @media (max-width: 1024px) {
    max-width: 90%;
    margin-bottom: 1.5rem;
  }
`;

const EarnProContent = styled.div`
  flex: 1;
  max-width: 550px;
  text-align: left;

  @media (max-width: 1024px) {
    max-width: 100%;
    text-align: center;
    margin-top: 1rem;
  }
`;

const Title = styled.h2`
    font-size: 40px;
  font-weight: 500;
  line-height: 43px; /* Improved readability */
  letter-spacing: -0.01em; /* Slight spacing for clarity */

  margin-bottom: 2rem;

  @media (max-width: 1024px) {
   font-size: 28px;
    margin-bottom: 1.5rem;
  }
`;

const Highlight = styled.span`
  color: #007bff;
`;

const EarnProButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media (max-width: 1024px) {
    align-items: center;
  }
`;

const Button = styled.a`
  background: black;
  color: white;
  font-size: 1rem;
  font-weight: 400;
  padding: 15px;
  border-radius: 6px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  transition: 0.3s;

  &:hover {
    background: #38a6fb;
    color: #ffffff;
  }

  @media (max-width: 1024px) {
    width: 100%;
    text-align: center;
    justify-content: center;
    font-size: 0.9rem;
    padding: 12px;
  }
`;

const OutlineButton = styled(Button)`
  background: transparent;
  color: black;
  border: 2px solid black;

  &:hover {
    color: #ffffff;
    border: 2px solid #38a6fb;
  }
`;

const ButtonArrow = styled(FaChevronRight)`
  font-size: 1.2rem;
  opacity: 0.8;

  @media (max-width: 1024px) {
    font-size: 1rem;
  }
`;

const EarnPro = ({
  isConsideredMobile,
  signedIn,
}) => {
  return (
    <>
      <EarnProContainer>
        <EarnProImage>
          <img src={Astronaut} alt="Astronaut Holding $PRO" width={500} height={500} priority />
        </EarnProImage>

        <EarnProContent>
          <Title>
            Wealth starts with ownership. Earn <Highlight>$PRO</Highlight> today:
          </Title>

          {/* Buttons */}
          <EarnProButtons>
            <Button href="https://propy.com/signup?chooseType=true">
              GET 10 PRO - SHARE OUR VISION VIDEO
              <ButtonArrow />
            </Button>

            <Button href="https://propy.com/signup?chooseType=true">
              GET MORE PRO - SIGN UP AND INVITE A FRIEND
              <ButtonArrow />
            </Button>

            <Button href="https://coinbase.propy.com/escrow/">
              GET $1000 IN PRO - REFER A FRIEND TO USE CRYPTO ESCROW
              <ButtonArrow />
            </Button>

            <OutlineButton href="https://www.coinbase.com/price/propy">
              BUY PRO TOKENS ON COINBASE
              <ButtonArrow />
            </OutlineButton>
          </EarnProButtons>
        </EarnProContent>
      </EarnProContainer>
    </>
  );
};

export default EarnPro;